<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Pesquisar Pessoa'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <div class="center">
                      <v-card outlined>
                        <v-card-text class="black--text font-weight-bold">
                          Para adicionar um novo integrante, realize a pesquisa pelo nome ou CPF da pessoa. Caso a pessoa desejada não seja encontrada, clique no botão "CADASTRAR MEMBRO EXTERNO" localizado no canto inferior direito.
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-space-between>
                  <v-flex xs6>
                    <v-radio-group v-model="tipoBusca" row>
                      <v-radio label="Nome" value="nome"></v-radio>
                      <v-radio label="CPF" value="cpf"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs8>
                    <v-text-field
                      v-show="tipoBusca==='nome'"
                      @keyup.enter="pesquisaPessoasPorNome"
                      label='Nome'
                      v-model="integrante.nome"
                      required
                      :rules="regrasBasicas"
                      max-height="400">
                    </v-text-field>
                    <v-text-field
                      v-show="tipoBusca!=='nome'"
                      @keyup.enter="pesquisaPessoasPorCpf"
                      label='CPF'
                      mask="###.###.###-##"
                      return-masked-value
                      v-model="integrante.cpf"
                      required
                      :rules="regrasBasicas"
                      max-height="400">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs4 style="padding-top:15px">
                    <v-btn v-if="tipoBusca==='nome'" color="primary" style="margin-left: 15px;" @click="pesquisaPessoasPorNome">Pesquisar</v-btn>
                    <v-btn v-else color="primary" style="margin-left: 15px;" @click="pesquisaPessoasPorCpf">Pesquisar</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>

            </v-form>

            <br><br>

            <v-divider></v-divider>

            <v-data-table
            :headers="headers"
            :items="listaPessoas"
            :search="search"
            :no-data-text="'Nenhuma pessoa encontrada'"
            must-sort
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :items-per-page="itemsPerPage"
            :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
            >
              <template v-slot:item.opcoes="props">
                <v-btn color="primary" @click="adicionarIntegrante(props.item.idPessoa)">Selecionar</v-btn>
                <v-btn v-if="administrador === true" color="primary" @click="editarPessoa(props.item.idPessoa)">Editar</v-btn>
              </template>
              <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
                Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaPessoas.length }} pessoas
              </template>
            </v-data-table>

            <br>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="$router.go(-1)">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="cadastrarMembroExterno()">Cadastrar Membro Externo</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import projetos from '@/utils/projetos'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      tipoBusca: 'nome',
      integrante: {
        nome: '',
        cpf: ''
      },
      listaPessoas: [],
      projeto: {},
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: 25,
      opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
      headers: [
        { text: 'Nome', align: 'center', value: 'nomePessoaUp' },
        { text: 'Vínculo', align: 'center', value: 'vinculo' },
        { text: 'Matrícula', align: 'center', value: 'matricula' },
        { text: 'CPF', align: 'center', value: 'cpf' },
        { text: 'Opções', align: 'center', value: 'opcoes' }
      ]
    }),
    computed: {
      ...mapGetters('auth', ['administrador'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      pesquisaPessoasPorNome () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando pessoas.' })
        projetos.getPessoasPorNome(this.integrante.nome)
        .then(response => {
          this.listaPessoas = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando pessoas.' })
        })
      },
      pesquisaPessoasPorCpf () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando pessoas.' })
        projetos.getPessoasPorCpf(this.integrante.cpf)
        .then(response => {
          this.listaPessoas = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando pessoas.' })
        })
      },
      adicionarIntegrante (idPessoa) {
        // Redireciona para a página de adicionar um integrante.
        this.$router.push({name: 'AdicionarIntegrante', params: {idProjeto: this.idProjeto, idPessoa: idPessoa}})
      },
      cadastrarMembroExterno (idPessoa) {
        this.$router.push({name: 'CadastrarMembroExterno', params: {idProjeto: this.idProjeto}})
      },
      editarPessoa (idPessoa) {
        this.$router.push({name: 'EditarPessoa', params: {idPessoa: idPessoa}})
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .center {
    text-align: center;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// novo-integrante.vue?8fade9b4